"use client";

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { apiBaseUrl, subdomain } from "@/config/api";

const cleanupAndRedirect = () => {
  localStorage.removeItem("isAuthentication");
  localStorage.removeItem("userData");
  localStorage.removeItem("wrapperData");
  localStorage.removeItem("wrapper");
  window.location.href = "/login";
};

// fetchBaseQuery expects a trailing slash for relative paths.
const baseUrl = `${apiBaseUrl}/`;

const rawBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    if (subdomain) {
      headers.set("X-Subdomain", subdomain);
    }
    return headers;
  },
  credentials: "include",
});

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    cleanupAndRedirect();
  }

  return result;
};

export const baseApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "Ticket",
    "Category",
    "Subcategory",
    "Subcategory",
    "TicketHistory",
    "Note",
    "TicketType",
    "Feedback",
    "Priority",
    "Company",
    "Group",
    "Agent",
    "AgentSkill",
    "Client",
    "UpdateReason",
    "Chat",
    "AgentGroup",
    "WorkShift",
    "Reports",
    "ClientGroup",
    "KbIssue",
    "KbSolution",
    "AIAgent",
    "CompanyInfo",
    "Dashboard"
  ],
  endpoints: (builder) => ({}),
});
